module.exports = __webpack_public_path__ + "img/acacia2.4595bf8c.png";